<template>
    <div>
        <v-card>
            <v-card-title>
                <span>Add Video Direct</span>
            </v-card-title>

            <v-card-text>
                <p>
                    <font-awesome-icon
                        icon="fa-solid fa-triangle-exclamation"
                        style="color: #facc16"
                        class="mr-2"
                    ></font-awesome-icon>
                    This will skip render/upload and save the video url directy <u>as-is</u>
                </p>
                <v-form ref="form" v-model="formValid">
                    <v-text-field
                        :rules="[v => !!v || 'This field is required']"
                        label="Converted Video Url"
                        v-model="videoUrl"
                    ></v-text-field>
                </v-form>
            </v-card-text>

            <v-card-actions class="d-flex justify-space-between">
                <v-btn depressed :disabled="loading" @click="$emit('close')">Cancel</v-btn>
                <v-btn depressed color="primary" :disabled="loading" :loading="loading" @click="handleSubmit"
                    >Submit</v-btn
                >
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import AdminToolService from '@/services/adminTool.service';
import { mapActions } from 'vuex';
export default {
    data() {
        return {
            token: '',
            apiService: '',
            loading: true,
            videoUrl: '',
            formValid: false,
        };
    },
    props: {
        event: {
            type: Object,
            default: () => {},
        },
    },
    methods: {
        ...mapActions(['showSnackbar']),
        async handleSubmit() {
            const isValid = this.$refs.form.validate();
            if (!isValid) return;
            try {
                this.loading = true;
                if (!this.apiService) throw new Error('Error occured during direct add');
                if (!this.event?.id) throw new Error('Event id not found');
                if (!this.videoUrl) throw new Error('Video url cannot be blank');
                const eventId = this.event.id;

                var resp = await this.apiService.directAddVideo(eventId, this.videoUrl);
                this.$emit('close');
                this.showSnackbar({ message: 'Video added' });
            } catch (error) {
                console.log(error, 'error');
                this.showSnackbar({ message: 'Error adding video', color: 'error' });
            } finally {
                this.loading = false;
            }
        },
        async setAuthToken() {
            const response = await this.$auth.getIdTokenClaims();
            this.token = response.__raw;
        },
    },
    async mounted() {
        await this.setAuthToken();

        this.apiService = AdminToolService(this.token);

        console.log(this.apiService, 'api');
        this.loading = false;
    },
};
</script>

<style lang="scss" scoped></style>
